module.exports = __webpack_public_path__ + "img/no-data.b70ddfd7.png";